<template>
    <!-- Mail modal -->
    <modalWindow
      @close="closeModal()"
      :bgtrigger="false"
      width="650"
    >
      <div class="titlebar">PSK mail versturen</div>
      <div class="inset">
        <span class="icon msg" style="margin: 0; border-radius: 0">
          <span class="icon">
            <awesomeIcon icon="exclamation-circle" />
          </span>
          Bij meerdere e-mailadressen, voeg een punt-komma (;) toe tussen de e-mailadressen zonder
          spatie.
          <br /><br />
          De mail wordt automatisch verstuurd naar u en de beheerder van de vragenlijst.
        </span>
        <customInput
          v-model="to"
          type="text"
          label="Aan"
          :disabled="$parent.view === 'afgerond'"
          :validation="['notrequired']"
        />
        <customInput
          v-model="subject"
          type="text"
          label="Onderwerp"
          :disabled="$parent.view === 'afgerond'"
          :validation="['notrequired']"
        />
        <h4 class="subheader">Voorbeeld mail</h4>
        <div style="padding: 10px; border: 1px solid black;">
          <span v-html="content" />
        </div>

        <div v-if="$parent.view !== 'afgerond'">
          <h4 class="subheader">Bijlagen</h4>
          <customInput
            type="file"
            :prefix="`overdrachten-${Number(transfer.psk_index)}-pskmail`"
            :validation="['files']"
            :intakeId="transfer.intake"
            :cb="getPsk"
          />
        </div>

        <div class="btns-right">
          <span
            v-if="errorText.length > 0"
            class="icon msg"
            style="margin-top: 10px; border-radius: 0"
          >
            <span class="icon">
              <awesomeIcon icon="exclamation-circle" />
            </span>
            <div v-for="(error, index) in errorText" :key="index">
              - {{error}} <br />
            </div>
          </span>
          <button
            @click="checkRequirementsToSendMail() ? sendPskMail() : ''"
          >
            Verstuur
            {{ transfer.mail_user ? 'reminder' : ''}}
            <awesomeIcon icon="paper-plane" />
          </button>
        </div>

        <span
          v-if="transfer.mail_user"
          class="icon msg"
          style="margin: 0; border-radius: 0"
        >
          <span class="icon">
            <awesomeIcon icon="paper-plane" />
          </span>
          {{ transfer.reminder_mail_user
              ? 'Reminder-mail'
              : 'Mail'
            }}
            verstuurd op
            {{
              transfer.reminder_mail_date
                ? new Date(transfer.reminder_mail_date).toLocaleString()
                : new Date(transfer.mail_date).toLocaleString()
            }} door
            {{
              transfer.reminder_mail_user
                ? filter(
                  $parent.users,
                  { id: transfer.reminder_mail_user }
                )[0].email
                : filter(
                  $parent.users,
                  { id: transfer.mail_user }
                )[0].email
            }}
        </span>

      </div>
    </modalWindow>
</template>
<script>
import { find, filter } from 'lodash-es';

export default {
  name: 'pskMail',
  emits: ['close'],
  props: {
    selectedPsk: Object,
  },
  data() {
    return {
      to: '',
      subject: '',
      content: '',
      transfer: {},
      errorText: [],
      files: '',
      pskMailModal: false,
      pskMailBanks: [
        { label: 'ABN', value: ['service.a.c.banksparen@nl.abnamro.com', 'psk@abnamroverzekeringen.nl'] },
        { label: 'AEGON', value: ['pskbank@aegon.nl', 'leven@aegon.nl'] },
        { label: 'Allianz', value: ['info.leven@allianz.nl'] },
        { label: 'AvéroAchmea', value: ['levensverzekering@avero.nl'] },
        { label: 'BrandNewDay', value: ['operations@brandnewday.nl', 'overboeken@brandnewday.nl'] },
        { label: 'CentraalBeheerAchmea', value: ['psk.lijfrentesparen@achmea.nl', 'levensverzekering@centraalbeheer.nl'] },
        { label: 'FlexGarant', value: ['info@flexgarant.nl'] },
        { label: 'GoudseLevensverzekeringen', value: ['leven@goudse.com'] },
        { label: 'Interpolis', value: ['levensverzekering@interpolis.nl'] },
        { label: 'NationaleNederlanden', value: ['nn.lp.proces.support@nn.nl'] },
        { label: 'OnderlingeLevensverzekering', value: ['info@ogmail.nl'] },
        { label: 'Rabobank', value: ['psk@rabobank.nl'] },
        { label: 'Scildon', value: ['servicedesk@scildon.nl'] },
        { label: 'SNS', value: ['psk.banksparen@sns.nl'] },
        { label: 'SRLEV', value: ['leven@reaal.nl'] },
        { label: 'Waard', value: ['T.Sterken@waardverzekeringen.nl'] },
      ],
    };
  },
  created() {
    if (this.transfer) {
      this.getPsk();
    }
  },
  methods: {
    filter,
    closeModal() {
      this.$emit('close');
    },
    getPsk() {
      this.sdk.getPsk(
        this.selectedPsk.intake,
        this.selectedPsk.psk_index,
        (response) => {
          if (response.status === 200) {
            response.data.files = JSON.parse(response.data.files);
            this.transfer = response.data;
            this.files = this.transfer.files;
            if (!this.to) {
              const mailObj = find(
                this.pskMailBanks,
                { label: this.transfer.institution_name },
              );
              this.to = mailObj ? mailObj.value.join(';') : '';
            }
            const customer = this.transfer.infix ? `${this.transfer.infix} ${this.transfer.surname}` : `${this.transfer.surname}`;
            if (!this.subject) {
              this.subject = `Overdrachtsverzoek ${this.transfer.polis_number || this.transfer.iban} ${customer}`;
            }
            this.content = `Geachte heer/mevrouw,<br><br>Bijgaand het overdrachtsverzoek van ${this.transfer.polis_number ? 'polis' : 'nummer'} ${this.transfer.polis_number || this.transfer.iban} ${customer}.<br>Hierbij het verzoek om de overdracht z.s.m. in behandeling te nemen.<br><br>Graag ontvangen wij een ontvangstbevestiging van deze e-mail.<br><i>Wilt u zo vriendelijk zijn om bij de omschrijving het volgende nummer toe te voegen: ${this.transfer.port}</i><br><br><br>Met vriendelijke groet,<br><br>Doelbeleggen.nl`;
          } else {
            this.$emit('close');
          }
        },
      );
    },
    sendPskMail() {
      const customer = this.transfer.infix ? `${this.transfer.infix} ${this.transfer.surname}` : `${this.transfer.surname}`;
      this.sdk.sendPskMail(
        this.transfer.intake,
        this.transfer.psk_index,
        this.to,
        this.subject,
        customer,
        (response) => {
          if (response.status === 200) {
            this.$emit('close');
            this.$parent.getPskList();
          } else {
            // Sending mail failed
            this.errorText = ['Er is iets misgegaan met het versturen de mail, probeer het nogmaals'];
            setTimeout(() => {
              this.errorText = [];
            }, 5000);
          }
        },
      );
    },
    checkRequirementsToSendMail() {
      const tempErrorArray = [];
      if (!this.to) {
        tempErrorArray.push('Geen geadresseerden');
      }
      if (!this.subject) {
        tempErrorArray.push('Geen onderwerp ingevoerd');
      }
      if (!this.content) {
        tempErrorArray.push('Geen content van de mail');
      }
      if (this.$parent.view === 'afgerond') {
        tempErrorArray.push('PSK is al afgerond');
      }
      if (Object.keys(this.transfer).length === 0) {
        tempErrorArray.push('Geen polis beschikbaar');
      } else {
        if (!this.transfer.surname) {
          tempErrorArray.push('Geen achternaam van de klant');
        }
        if (!this.transfer.port) {
          tempErrorArray.push('Geen portefeuillenummer');
        }
        if (filter(
          this.transfer.files,
          (o) => o.path.includes(
            `overdrachten-${Number(this.transfer.psk_index)}-pskmail`,
          ),
        ).length < 1) {
          tempErrorArray.push('Niet genoeg bestanden geüpload');
        }
      }
      this.errorText = [...tempErrorArray];
      return tempErrorArray.length === 0;
    },
  },
};
</script>
